import { useEffect, useState } from "react";
import axios from "axios";
import { Button, Card, Form, Input, InputNumber, Space, Typography, message, Divider, Popconfirm } from "antd";

const { Title, Text } = Typography;

export default function MembershipPlans() {
  //const [edit, setEdit] = useState(false);
  const [plans, setPlans] = useState([]);
  const [form] = Form.useForm();

  const fetchPlans = async () => {
    const res = await axios.get("https://tkvxunknf5cpphpnkewzthvv4q0gzins.lambda-url.us-east-1.on.aws/membership-plans");
    setPlans(res.data);
  };

  useEffect(() => {
    fetchPlans();
  }, []);

  const createPlan = async () => {
    const values = await form.validateFields();
    const formatted = {
      ...values,
      planDuration: parseInt(values.planDuration),
      planCost: parseInt(values.planCost),
    };
    await axios.post("https://tkvxunknf5cpphpnkewzthvv4q0gzins.lambda-url.us-east-1.on.aws/membership-plans", formatted);
    message.success("Plan added!");
    form.resetFields();
    fetchPlans();
  };
  

  const updatePlan = async (planId, updatedData) => {
    const formatted = {
      ...updatedData,
      planDuration: parseInt(updatedData.planDuration),
      planCost: parseInt(updatedData.planCost),
    };
    await axios.put(`https://tkvxunknf5cpphpnkewzthvv4q0gzins.lambda-url.us-east-1.on.aws/membership-plans/${planId}`, formatted);
    message.success("Plan updated!");
    fetchPlans();
  };
  

  const deletePlan = async (planId) => {
    await axios.delete(`https://tkvxunknf5cpphpnkewzthvv4q0gzins.lambda-url.us-east-1.on.aws/membership-plans/${planId}`);
    message.success("Plan deleted!");
    fetchPlans();
  };

  return (
    <Space direction="vertical" style={{ width: "100%" }}>
      <Card title="🆕 Add New Membership Plan" bordered>
        <Form form={form} layout="vertical" onFinish={createPlan}>
          <Form.Item label="Plan Name" name="planName" rules={[{ required: true }]}>
            <Input placeholder="e.g. Weekly Plan" />
          </Form.Item>
          <Form.Item label="Duration (Days)" name="planDuration" rules={[{ required: true }]}>
            <InputNumber style={{ width: "100%" }} placeholder="e.g. 7" />
          </Form.Item>
          <Form.Item label="Cost (₹)" name="planCost" rules={[{ required: true }]}>
            <InputNumber style={{ width: "100%" }} placeholder="e.g. 250" />
          </Form.Item>
          <Form.Item label="UPI VPA" name="upiVPA" rules={[{ required: true }]}>
            <Input placeholder="e.g. name@upi" />
          </Form.Item>
          <Form.Item label="UPI Name" name="upiName" rules={[{ required: true }]}>
            <Input placeholder="e.g. Your Name" />
          </Form.Item>
          <Button type="primary" htmlType="submit">Add Plan</Button>
        </Form>
      </Card>

      <Divider />

      <Title level={4}>📋 All Plans</Title>
      {plans.map((plan) => (
        <EditablePlan key={plan.planId} plan={plan} onUpdate={updatePlan} onDelete={deletePlan} />
      ))}
    </Space>
  );
}

function EditablePlan({ plan, onUpdate, onDelete }) {
  const [editing, setEditing] = useState(false);
  const [form] = Form.useForm();

  const handleSave = async () => {
    const values = await form.validateFields();
    onUpdate(plan.planId, values);
    setEditing(false);
  };

  return (
    <Card
      title={`📦 ${plan.planName}`}
      extra={
        editing ? (
          <Space>
            <Button onClick={handleSave} type="primary">Save</Button>
            <Button onClick={() => setEditing(false)}>Cancel</Button>
          </Space>
        ) : (
          <Space>
            <Button onClick={() => setEditing(true)}>Edit</Button>
            <Popconfirm
              title="Are you sure you want to delete this plan?"
              onConfirm={() => onDelete(plan.planId)}
              okText="Yes"
              cancelText="No"
            >
              <Button danger>Delete</Button>
            </Popconfirm>
          </Space>
        )
      }
      style={{ background: "#f9f9f9" }}
    >
      {editing ? (
        <Form form={form} layout="vertical" initialValues={plan}>
          <Form.Item name="planName" label="Plan Name" rules={[{ required: true }]}>
            <Input />
          </Form.Item>
          <Form.Item name="planDuration" label="Duration (Days)" rules={[{ required: true }]}>
            <InputNumber style={{ width: "100%" }} />
          </Form.Item>
          <Form.Item name="planCost" label="Cost ₹" rules={[{ required: true }]}>
            <InputNumber style={{ width: "100%" }} />
          </Form.Item>
          <Form.Item name="upiVPA" label="UPI VPA" rules={[{ required: true }]}>
            <Input />
          </Form.Item>
          <Form.Item name="upiName" label="UPI Name" rules={[{ required: true }]}>
            <Input />
          </Form.Item>
        </Form>
      ) : (
        <div>
          <Text><strong>Duration:</strong> {plan.planDuration} days</Text><br />
          <Text><strong>Cost:</strong> ₹{plan.planCost}</Text><br />
          <Text><strong>UPI:</strong> {plan.upiVPA} ({plan.upiName})</Text>
        </div>
      )}
    </Card>
  );
}
